// src/components/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Auth } from "../helpers/auth";

function isValidUser(u) {
  // require at least one stable identifier
  return !!(u && (u.id || u._id || u.email));
}

export default function RequireAuth({ children }) {
  const [state, setState] = React.useState({ loading: true, user: null });
  const loc = useLocation();

  React.useEffect(() => {
    let dead = false;
    (async () => {
      try {
        const me = await Auth.me(); // GET /auth/me
        console.log(me);
        const user = isValidUser(me?.user) ? me.user : null;
        if (!dead) setState({ loading: false, user });
      } catch {
        if (!dead) setState({ loading: false, user: null });
      }
    })();
    return () => {
      dead = true;
    };
  }, []);

  if (state.loading) return <div className="authGate" aria-busy="true" />;

  if (!state.user) {
    const returnTo = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/signin?returnTo=${returnTo}`} replace />;
  }

  return children;
}
